import React from "react";
import "./loadingComponent.scss";

export const LoadingComponent = () => {
  return (
    <div id="splashScreen">
      <div className="loader-wrapper">
        <span className="loader">
          <span className="loader-inner"></span>
        </span>
      </div>
    </div>
  );
};